import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useStore as useAuthStore } from "auth/store";
import {
  GetCleaningCompanies_cleaningCompany as GetCleaningCompaniesDataGenerated,
  GetCleaningCompanies as GetCleaningCompaniesGenerated,
  GetCleaningCompaniesVariables as GetCleaningCompaniesVariablesGenerated,
} from "core/queries/__generated__/GetCleaningCompanies";

export interface GetCleaningCompaniesData
  extends GetCleaningCompaniesDataGenerated {}
export interface GetCleaningCompaniesVariables
  extends GetCleaningCompaniesVariablesGenerated {}
export interface GetCleaningCompaniesResponse
  extends GetCleaningCompaniesGenerated {}

export const getCleaningCompanies = gql`
  query GetCleaningCompanies($filters: CleaningCompanyFilterInput!) {
    cleaningCompany(filters: $filters) {
      id
      name
    }
  }
`;

export interface UseGetCleaningCompaniesOptions {
  skip?: boolean;
  variables: GetCleaningCompaniesVariables;
}

export const useGetCleaningCompanies = ({
  skip = false,
  variables,
}: UseGetCleaningCompaniesOptions) =>
  useQuery<GetCleaningCompaniesResponse>(getCleaningCompanies, {
    skip,
    variables,
  });

export const useRolesBasedGetCleaningCompanies = ({
  skip = false,
  variables,
}: UseGetCleaningCompaniesOptions) => {
  const {
    state: { user: loggedInUser },
  } = useAuthStore();
  return useGetCleaningCompanies({
    skip: !loggedInUser?.isCleaningManager || skip,
    variables,
  });
};
